<template>
  <v-row row wrap justify="center" align="center" v-if="current_user.is_super_admin">
    <v-col cols="12" sm="12" md="10" lg="8" xl="8">
      <v-card flat text class="mt-4 px-2">
        <!-- <v-form autocomplete="false" data-vv-scope="form" @submit="checkUser" lazy-validation> -->
        <v-row wrap>
          <v-col cols="12" sm="10" md="10" lg="10" class="pb-0">
            <v-text-field
              outlined
              dense
              autocomplete="false"
              name="Alamat Surel Pengguna"
              placeholder="Masukkan alamat surel pengguna yang akan dicari"
              label="Surel"
              v-model="user.email"
              persistent-hint
              @keyup.13.prevent="checkUser"
              data-vv-name="email"
              data-vv-as="Surel"
              :error-messages="errors.collect('form.email')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2">
            <m-button textButton="Cari" icon="mdi-magnify" action="checkUser" @checkUser="checkUser"></m-button>
          </v-col>
        </v-row>
        <!-- </v-form> -->
      </v-card>
    </v-col>
    <v-col cols="12" v-if="detil">
      <m-card title="Detil Pengguna">
        <v-row wrap>
          <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pr-2 text-center">
            <v-card text color="#fff" flat>
              <v-container fill-height container--fluid>
                <v-row fill-height>
                  <v-col class="text-center" cols="12" align-end colbox>
                    <img
                      height="200"
                      src="https://cdn.siap.id/s3/asset illustrasi/Illustrasi/bg-default.png"
                      alt="avatar"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" sm="9" md="9" lg="9" xl="9">
            <v-list>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Nama</v-list-item-subtitle>
                      <div class="primary--text title">{{ pVal(detil, "name") }}</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption">Surel</v-list-item-subtitle>
                      <div class="primary--text">{{ pVal(detil, "email") }}</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-chip
                        width="100"
                        v-if="detil.is_angkatan1"
                        small
                        outlined
                        class="amber amber--text font-weight-bold justify-center ma-0 mt-2"
                        >Penyegaran (1 - 4 Juli 2020)</v-chip
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div v-for="(instansi, index) in detil.instansis" :key="instansi.index">
              <p class="title primary--text">Instansi ke - {{ index + 1 }} : {{ pVal(instansi, "nama") }}</p>
              <v-card outlined>
                <v-card-title class="black--text">Tersinkron ke</v-card-title>
                <v-card-text>
                  <div v-for="grup in instansi.grup" :key="grup.index">
                    <span class="black--text">
                      Jenis Diklat :
                      <b class="primary--text">{{ grup.jenisdiklat.keterangan }}</b>
                    </span>
                    <span class="black--text">
                      sebagai
                      <v-chip outlined color="secondary" class="ma-1">{{ grup.grupsimpkb.keterangan }}</v-chip>
                    </span>
                  </div>
                </v-card-text>
              </v-card>
              <br />
              <v-card outlined>
                <v-card-title class="black--text">Diklat yang pernah diikuti</v-card-title>
                <v-card-text v-if="instansi.diklats.length > 0">
                  <div v-for="diklat in instansi.diklats" :key="diklat.index">
                    <span class="primary--text font-weight-bold">Diklat : {{ diklat.keterangan }}</span>
                    <div v-for="kelas in diklat.kelas[0]" :key="kelas.index">
                      <span class="font-weight-bold teal--text"
                        >Kelas : {{ kelas.kelas.nama }} ({{ pVal(kelas.kelas, "tanggal_mulai") | toDT }} s/d
                        {{ pVal(kelas.kelas, "tanggal_selesai") | toDT }})</span
                      >
                      sebagai
                      <v-chip outlined color="orange" class="ma-1">{{ pVal(kelas.grup, "keterangan") }}</v-chip>
                      <br />
                      <div class="my-1" v-for="kelasmodul in kelas.kelas.kelasmodul" :key="kelasmodul.index">
                        <span class="font-weight-bold">Modul : {{ pVal(kelasmodul, "nama") }}</span>
                        <span class="mx-1">
                          <m-button
                            small
                            textButton="Tautan"
                            icon="mdi-link"
                            :large="false"
                            action="toCourse"
                            color="success"
                            dark
                            @toCourse="toCourse(kelasmodul)"
                          ></m-button>
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-card-text v-else>
                  <span class="error--text">Tidak pernah mengikuti diklat di instansi ini</span>
                </v-card-text>
              </v-card>
              <br />

              <v-divider></v-divider>
            </div>
          </v-col>
        </v-row>
      </m-card>
    </v-col>
  </v-row>
  <div v-else>
    <span class="title">Anda tidak berhak mengakses halaman ini</span>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      user: {
        email: null
      },
      detil: null
    };
  },
  methods: {
    checkUser() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store
            .dispatch("user/searchUser", {
              params: {
                email: this.user.email
              }
            })
            .then(res => {
              this.detil = res;
            });
        })
        .catch(e => e);
    },
    toCourse(val) {
      window.open(val.link_moodle, "_blank");
    }
  }
};
</script>
